import { NotificationsPage } from '@agentic-flow-studio/shared/components/notifications/NotificationsPage';
import { pushDriver } from '@/lib/push';

/** Binds the shared inbox to this app's routes and push registration. */
export default function Notifications() {
  return <NotificationsPage app="anchor-portal" driver={pushDriver} />;
}
